import { useEffect, useState } from 'react';
import { parseChangelogData } from 'modules/workflows/utils';
import { Changelog } from '../Changelog';
import { RevisionData, ParsedChangelogData } from './types';

import { Labels, ChangelogContainer, SelectedRevisionChangelog, NoData } from './styles';

export const SELECTED_REVISION_CHANGELOG_ROW_ID = 'selected-revision-changelog-row';
export const SELECTED_REVISION_CHANGELOG_RESULTS_ID = 'selected-revision-changelog-results';
export const SELECTED_REVISION_CHANGELOG_NONE_ID = 'selected-revision-changelog-none';

export type RevisionChangelogProps = {
  revisionData?: RevisionData;
};

export const RevisionChangelog = ({ revisionData }: RevisionChangelogProps) => {
  const [parsedData, setParsedData] = useState<ParsedChangelogData[] | undefined>();

  useEffect(() => {
    if (revisionData) {
      const parsed = parseChangelogData(revisionData?.revisionSummary);
      setParsedData(parsed);
    }
  }, [revisionData]);

  return (
    <ChangelogContainer>
      <Labels>Changes in this version</Labels>
      <SelectedRevisionChangelog>
        {parsedData?.length ? (
          <Changelog
            parsedData={parsedData}
            changelogRowTest={SELECTED_REVISION_CHANGELOG_ROW_ID}
            changelogTableTest={SELECTED_REVISION_CHANGELOG_RESULTS_ID}
          />
        ) : (
          // in the case there are no differences from prior versions
          <NoData data-test={SELECTED_REVISION_CHANGELOG_NONE_ID}>No differences were found</NoData>
        )}
      </SelectedRevisionChangelog>
    </ChangelogContainer>
  );
};
